/*
 * Сводка GitLab платформы (плагин viva-gitlab): загружается один раз на страницу ресурса gitlab и
 * делится карточками «GitLab платформы» и «Обновления» через контекст.
 */
import { createContext, ReactNode, useContext } from 'react';
import { discoveryApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';
import { fetchGitlabSummary, GitlabSummary } from '../../../lib/gitlab';

type State = { loading: boolean; error?: Error; value?: GitlabSummary };

const Ctx = createContext<State | undefined>(undefined);

export const GitlabSummaryProvider = ({ children }: { children: ReactNode }) => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const state = useAsync(() => fetchGitlabSummary({ discoveryApi, fetchApi }), []);
  return <Ctx.Provider value={state}>{children}</Ctx.Provider>;
};

export const useGitlabSummary = (): State => {
  const state = useContext(Ctx);
  if (!state) {
    throw new Error('useGitlabSummary вне GitlabSummaryProvider');
  }
  return state;
};
